import { render, staticRenderFns } from "./sort-table-column-button.vue?vue&type=template&id=ef3ba856&scoped=true&lang=pug&"
import script from "./sort-table-column-button.vue?vue&type=script&lang=ts&"
export * from "./sort-table-column-button.vue?vue&type=script&lang=ts&"
import style0 from "./sort-table-column-button.vue?vue&type=style&index=0&id=ef3ba856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3ba856",
  null
  
)

export default component.exports